var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57141 10.6978V14.2254C4.57141 14.7104 4.96826 15.1072 5.45329 15.1072H8.09893L11.0003 18.0086C11.5559 18.5642 12.5083 18.1674 12.5083 17.3825V7.53189C12.5083 6.74702 11.5559 6.35018 11.0003 6.90576L8.09893 9.81596H5.45329C4.96826 9.81596 4.57141 10.2128 4.57141 10.6978ZM16.4768 12.4616C16.4768 10.9007 15.5773 9.56022 14.2721 8.90763V16.0068C15.5773 15.363 16.4768 14.0225 16.4768 12.4616ZM14.2721 5.80341V5.97979C14.2721 6.3149 14.4926 6.60592 14.8012 6.72938C17.0765 7.63772 18.6815 9.86887 18.6815 12.4616C18.6815 15.0543 17.0765 17.2855 14.8012 18.1938C14.4837 18.3173 14.2721 18.6083 14.2721 18.9434V19.1198C14.2721 19.6754 14.8277 20.0634 15.3392 19.8694C18.3287 18.7318 20.4452 15.848 20.4452 12.4616C20.4452 9.07518 18.3287 6.19144 15.3392 5.05381C14.8277 4.85098 14.2721 5.24783 14.2721 5.80341V5.80341Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.801affbe93ea5ff47c8ddf7fbe661d20.svg";
export { ForwardRef as ReactComponent };